module.exports = __webpack_public_path__ + "static/img/step1.6989ec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/guide/step1.png
// module id = dIDm
// module chunks = 1